import FrameStock from './FrameStock'

export * from './FrameStock'

export default FrameStock
